// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tabs__container___U18Xe {
    overflow: auto;
    display: flex;
    flex: 1 1 auto;
}

.Tabs__icon___NvCbv {
    display: flex;
    flex: 0 0 4rem;
    align-items: center;
    justify-content: center;

    color: var(--color-typo-secondary);

    background: var(--color-bg-secondary);

    &:hover {
        color: var(--color-typo-primary);
        background: var(--color-bg-default);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkAreas/Tabs/Tabs.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;;IAEvB,kCAAkC;;IAElC,qCAAqC;;IAErC;QACI,gCAAgC;QAChC,mCAAmC;IACvC;AACJ","sourcesContent":[".container {\n    overflow: auto;\n    display: flex;\n    flex: 1 1 auto;\n}\n\n.icon {\n    display: flex;\n    flex: 0 0 4rem;\n    align-items: center;\n    justify-content: center;\n\n    color: var(--color-typo-secondary);\n\n    background: var(--color-bg-secondary);\n\n    &:hover {\n        color: var(--color-typo-primary);\n        background: var(--color-bg-default);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tabs__container___U18Xe`,
	"icon": `Tabs__icon___NvCbv`
};
export default ___CSS_LOADER_EXPORT___;
